import { Tooltip as FlowbiteTooltip, TooltipProps } from 'flowbite-react'
import React from 'react'
import { classNameBuilder } from '@/helpers'

type Props = {
  children: React.ReactNode
  content: React.ReactNode
  style?: TooltipProps['style']
  placement?: TooltipProps['placement']
  arrow?: TooltipProps['arrow']
  animation?: TooltipProps['animation']
  theme?: TooltipProps['theme']
  className?: string
}

export const Tooltip: React.FC<Props> = ({
  children,
  content,
  style = 'light',
  className,
  ...tooltipProps
}) => {
  return (
    <FlowbiteTooltip
      content={content}
      style={style}
      className={classNameBuilder(
        'z-[90] rounded-[16px] border-none p-8 text-[#000000] shadow-md',
        className
      )}
      {...tooltipProps}
    >
      {children}
    </FlowbiteTooltip>
  )
}

export default Tooltip
